'use client';

import type { ReactNode } from 'react';
import { SkBaseStyles, SkStyles } from '../styles/SkStyles';
import { palette } from '../styles/palette';

// Concrete catalogue routes do not carry the authored page's token payload.
// Keep these defaults local to the kitchen surface; other tenants keep their own theme.
const CSS = `
.sk-catalogue{
  --color-brand-500:${palette.sage};--color-brand-600:${palette.sageDeep};
  --color-text-primary:${palette.ink};--color-text-secondary:${palette.muted};
  --color-text-muted:${palette.muted};--color-text-on-brand:#fff;
  --color-text-link:${palette.sageDeep};--color-surface-muted:${palette.sageGrey};
  --color-surface-subtle:${palette.warm};--color-surface-card:${palette.white};
  --color-border-subtle:${palette.border};--color-border-default:${palette.border};
  --font-family-display:'Fraunces',Georgia,serif;--font-family-base:'Manrope',system-ui,sans-serif;
  --radius-card:14px;--radius-button:999px;
  font-family:var(--font-family-base);color:var(--color-text-primary);background:${palette.warm};
}
.sk-catalogue h1,.sk-catalogue h2{font-family:var(--font-family-display);font-weight:500;letter-spacing:-.01em;line-height:1.15}
.sk-catalogue h1{font-size:clamp(1.875rem,1.3rem + 2vw,3rem);overflow-wrap:anywhere}
.sk-catalogue button,.sk-catalogue input,.sk-catalogue select{font:inherit}
.sk-catalogue input:not([type=checkbox]):not([type=radio]),.sk-catalogue select{min-height:44px;border-color:${palette.controlBorder};border-radius:9px}
.sk-catalogue button:disabled{cursor:not-allowed}
.sk-catalogue [data-product-media] img{object-fit:contain;background:${palette.warm}}
.sk-catalogue [data-product-summary]{min-width:0}
.sk-catalogue [data-product-detail]{padding-block:2rem 3rem}
.sk-catalogue [data-product-layout="text"]{display:block;max-width:50rem}
.sk-catalogue [data-product-layout="text"] [data-product-summary]{border:0;padding-left:0;position:static}
@media(max-width:639px){.sk-catalogue input,.sk-catalogue select,.sk-catalogue textarea{font-size:16px}}
`;

export function KitchenCatalogueSurface({ children }: { children: ReactNode }) {
  return (
    <div className="sk sk-catalogue" data-sk-skin="catalogue">
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600&family=Manrope:wght@400;500;600;700;800&display=swap" />
      <SkBaseStyles />
      <SkStyles id="catalogue" css={CSS} />
      {children}
    </div>
  );
}
